import { render, staticRenderFns } from "./OrderSize.vue?vue&type=template&id=51c02eae"
import script from "./OrderSize.vue?vue&type=script&lang=js"
export * from "./OrderSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports